export const STUDENT_CREDIT_STATE_CHANGED_EVENT = "wmf:student-credit-state-changed";

export interface StudentCreditStateChangedDetail {
  studentId: string;
}

export function notifyStudentCreditStateChanged(studentId: string): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<StudentCreditStateChangedDetail>(STUDENT_CREDIT_STATE_CHANGED_EVENT, {
      detail: { studentId },
    }),
  );
}

export function studentCreditStateChangedFor(event: Event, studentId: string): boolean {
  return (
    event instanceof CustomEvent &&
    (event as CustomEvent<StudentCreditStateChangedDetail>).detail?.studentId === studentId
  );
}
